<template>
    <v-card outlined elevation="0" class="d-flex justify-center" style="overflow:hidden">
        <v-select v-model="query['code']" v-bind="{ items }" prefix="교환소: " dense flat solo hide-details class="text-caption" style="margin:-1px;width:180px" @change="emit" />
    </v-card>
</template>

<script>
import { USER_EXCHANGE_CODES } from "@/assets/lib";

const initQuery = (query = {}) => ({
    ...(query || {}),
    ["code"]: query?.["code"] || "null",
});

const items = [{ text: "전체", value: "null" }, ...Object.values(USER_EXCHANGE_CODES)];

export default {
    data: () => ({
        query: initQuery(),
        items,
    }),
    methods: {
        sync() {
            this.query = initQuery(this.$route.query);
        },
        emit() {
            let { ...query } = this.query;

            delete query.page;

            if (query["code"] == "null") delete query["code"];

            this.$router.push({ query });
        },
    },
    watch: {
        "$route.query"() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .v-select__selection.v-select__selection--comma {
        margin: 0 !important;
    }
    .v-input__slot {
        padding-right: 4px !important;
    }
}
</style>
